export default "__VITE_ASSET__DlfiuA3L__"